// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1uOMb","image":"Header_image__3qVM6","name":"Header_name__ndaRL","info":"Header_info__106Di","infoRow":"Header_infoRow__2-Ozr"};